import { createSlice, nanoid, PayloadAction } from '@reduxjs/toolkit';

export interface AlertItem {
  id: string;
  message: string;
  severity: 'success' | 'warning';
}

interface AlertState {
  alerts: AlertItem[];
}
type NewAlert = Omit<AlertItem, 'id'>;

const initialState: AlertState = { alerts: [] };

const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    addAlert: {
      reducer: (state, action: PayloadAction<AlertItem>) => {
        state.alerts.push(action.payload);
      },
      prepare: (alert: NewAlert) => {
        return {
          payload: {
            ...alert,
            id: nanoid(),
          },
        };
      },
    },
    removeAlert: (state, action: PayloadAction<string>) => {
      state.alerts = state.alerts.filter((alert) => alert.id !== action.payload);
    },
  },
});

export const { addAlert, removeAlert } = alertsSlice.actions;
export default alertsSlice.reducer;
